// extracted by mini-css-extract-plugin
export default {"overlay":"OldModal-module__overlay__sYGNG","content":"OldModal-module__content__DLbj1","close":"OldModal-module__close__RU56U"};